import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Import Router and Route components
import HeroSection from "./Components/HeroSection";
import TravelPackages from "./Components/TravelPackage/TravelPackages";
import Footer from "./Components/Footer/Footer";
import "./App.css";
import Home from "./Pages/Home";
import DetailPage from "./Pages/DetailPage";
import Layout from "./Layout"; // Import the Layout component


const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
           <Route path="/" element={<Home />} />
           <Route path="/detail" element={<DetailPage />} /> 
          {/* <Route path="/" element={<CommunityHighlightsPage/>} /> */}
          {/* Add more routes as needed */}
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
